import { indexBy, prop, omit } from 'ramda';

import * as appointmentTasksTypes from 'modules/appointmentTask/actionTypes';
import * as interventionActionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = {};

const appointmentCleaner = appointment => ({
  ...omit(['links', 'createdBy', 'dealer', 'events', 'intervention', 'appointmentTasks'], appointment),
  ...(appointment?.createdBy ? { createdBy: appointment.createdBy.id } : {}),
  ...(appointment?.dealer ? { dealerId: appointment.dealer.id } : {}),
  ...(appointment?.intervention ? { interventionId: appointment.intervention.id } : {}),
  ...(appointment?.events ? { events: appointment.events.map(event => (event?.id ? event.id : event)) } : {}),
  ...(appointment?.appointmentTasks ? { appointmentTasksIds: appointment.appointmentTasks.map(({ id }) => id) } : {}),
});

const updateAll = (state, { payload }) => ({
  ...state,
  ...indexBy(prop('id'))(
    payload.content.map(appointment => appointmentCleaner({ ...state?.[appointment.id], ...appointment }))
  ),
});

const updateOne = (state, { payload }) => ({
  ...state,
  [payload.id]: {
    ...(state?.[payload.id] ?? {}),
    ...appointmentCleaner(payload),
  },
});

const updateFromAttentionPoints = (state, { payload }) => {
  const appointments = payload.map(({ appointment }) => appointment);
  return {
    ...state,
    ...indexBy(prop('id'))(appointments.map(appointment => ({ ...(state?.[appointment.id] ?? {}), ...appointment }))),
  };
};

const deleteOne = (state, { payload: appointmentId }) => {
  const { [appointmentId]: appointmentToDelete, ...appointments } = state;
  return { ...appointments };
};

const addAppointmentTask = (state, { payload, meta }) => ({
  ...state,
  [meta.appointmentId]: {
    ...state[meta.appointmentId],
    appointmentTasksIds: [...(state[meta.appointmentId].appointmentTasksIds ?? []), payload.id],
  },
});

const deleteAppointmentTask = (state, { payload }) => {
  const { id: taskId, appointmentId } = payload;
  const appointment = { ...state[appointmentId] };

  if (appointment) {
    const appointmentTasksIds = appointment.appointmentTasksIds?.filter(id => id !== taskId) ?? [];
    return {
      ...state,
      [appointmentId]: {
        ...appointment,
        appointmentTasksIds,
      },
    };
  }
  return state;
};

const updateShareLink = (state, { payload }) => ({
  ...state,
  [payload.id]: {
    ...(state?.[payload.id] ?? {}),
    shareLink: payload.shareLink,
  },
});

export default createReducer(initialState, {
  [actionTypes.FETCH_APPOINTMENTS_SUCCESS]: updateAll,

  [actionTypes.PUT_SUCCESS]: updateOne,
  [actionTypes.POST_SUCCESS]: updateOne,
  [interventionActionTypes.POST_SEND_BY_SUCCESS]: updateOne,
  [actionTypes.PATCH_STATUS_SUCCESS]: updateOne,
  [actionTypes.FETCH_EVENTS_SUCCESS]: updateOne,
  [actionTypes.FETCH_APPOINTMENT_SUCCESS]: updateOne,
  [actionTypes.FETCH_INTERVENTION_SUCCESS]: updateOne,

  [actionTypes.FETCH_SHARE_LINK_SUCCESS]: updateShareLink,

  [actionTypes.DELETE_SUCCESS]: deleteOne,

  [appointmentTasksTypes.POST_SUCCESS]: addAppointmentTask,
  [appointmentTasksTypes.RESCHEDULE_SUCCESS]: addAppointmentTask,

  [appointmentTasksTypes.DELETE_SUCCESS]: deleteAppointmentTask,

  [actionTypes.FETCH_ATTENTION_POINTS_SUCCESS]: updateFromAttentionPoints,
});
